<template>
  <div class="wrapper"></div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.$http({
      url: "/system/info/loginGaoKe",
      type: "GET"
    }).then(res => {
      window.open(res.data, "_blank");
    });
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>